import { STATUS_CONFIG } from '../helpers';

const PlaylistDetail = ({ playlist }) => {
  const statusConfig = STATUS_CONFIG[playlist.status] || STATUS_CONFIG.pending;

  return (
    <div className="d-flex align-items-center justify-content-between py-2 px-3 border-bottom last-child-no-border">
      <div className="d-flex align-items-center gap-2">
        <i
          aria-hidden="true"
          style={{ fontSize: '0.7rem' }}
          className={`fas ${statusConfig.icon}`}
        />

        <small className="fw-medium">
          {playlist.name || 'Untitled playlist'}
        </small>
      </div>

      <div className="d-flex align-items-center gap-3">
        {playlist.sourceTrackCount != null && (
          <small className="text-muted">
            {playlist.targetTrackCount}/{playlist.sourceTrackCount} tracks
          </small>
        )}

        <small
          title={statusConfig.title.playlist}
          className={`${statusConfig.className} cursor-pointer`}
        >
          {statusConfig.label}
        </small>
      </div>
    </div>
  );
};

export default PlaylistDetail;
